<template>
	<router-view :key="$route.fullPath"></router-view>
	<!-- <Footer v-if="!this.mobile"></Footer> -->
	<!-- <Spinner v-if="isLoading"></Spinner> -->
</template>

<script>
// import Spinner from '@/components/Layout/Spinner';
import Urls from './assets/entry/urlpaths';
import 'swiper/swiper.min.css';
import 'v-calendar/dist/style.css';
import 'swiper/modules/navigation/navigation.min.css';
import 'swiper/modules/pagination/pagination.min.css';
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css';
// import Footer from '@/components/Layout/Footer';
import { isMobile } from '@/common/mobile';
import { mapGetters } from 'vuex';

export default {
	name: 'App',
	components: {},
	methods: {
		injectStyle(id, hrefList) {
			if (document.getElementById(id)) return;

			hrefList.forEach((href, i) => {
				const link = document.createElement('link');
				link.id = `${id}-${i}`;
				link.rel = 'stylesheet';
				link.href = href;
				document.head.appendChild(link);
			});
		},
	},
	data() {
		return {
			isModalViewed: false,
			mobile: isMobile(),
		};
	},
	computed: {
		...mapGetters('common', ['isLoading']),
	},
	mounted() {
		if (typeof window === 'undefined') return;
		const url = window.location.pathname;
		const loadStyles = (id, hrefs) => {
			hrefs.forEach(href => {
				const link = document.createElement('link');
				link.id = id;
				link.rel = 'stylesheet';
				link.href = href;
				document.head.appendChild(link);
			});
		};
		if (!Urls.includes(url)) {
			loadStyles('main-style', [
				'/css/common.css',
				'/css/index.css',
				'/css/tutorial.css',
				'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css',
			]);
		} else {
			loadStyles('bootstrap-style', [
				'https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/css/bootstrap.min.css',
			]);
		}
	},
};
</script>

<!-- <style>
@import './assets/css/common.css';
@import './assets/css/index.css';
@import './assets/css/tutorial.css';
</style> -->
